import { api } from "./api";

export const sendChat = ({ conversation_id, name, text }) =>
  api.post("/chat/message", { conversation_id, name, text }).then((r) => r.data);

export const getChat = (cid) => api.get(`/chat/${cid}/messages`).then((r) => r.data);

export const listConversations = () => api.get("/chat/conversations").then((r) => r.data);

export const replyChat = (cid, text) =>
  api.post(`/chat/${cid}/reply`, { text }).then((r) => r.data);
